<template>
  <v-row justify="center">
    <v-dialog :value="dialog" max-width="600" persistent @input="close">
      <v-card>
        <DialogCardTitle :title="title" @close="close" />

        <v-card-text class="pa-6">
          <slot />
        </v-card-text>

        <DialogCardActions
          v-if="isShowActionBtn"
          :is-show-mode="isShowMode"
          :is-edit="isEdit"
          :is-invalid="isInvalid"
          :save-btn-loading="saveBtnLoading"
          :title-for-confirm="titleForConfirm"
          @close="close"
          @save="save"
        >
          <template #leftActions>
            <slot name="leftActions" />
          </template>

          <template #rightActions>
            <slot name="rightActions" />
          </template>
        </DialogCardActions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import DialogCardTitle from './DialogCardTitle'
import DialogCardActions from './DialogCardActions'

export default {
  name: 'BaseDialog',

  components: { DialogCardActions, DialogCardTitle },

  props: {
    title: {
      type: String,
      default: '',
    },
    dialog: Boolean,
    isShowMode: Boolean,
    saveBtnLoading: Boolean,
    isEdit: Boolean,
    titleForConfirm: {
      type: String,
      default: '',
    },
    isInvalid: {
      type: Boolean,
      default: false,
    },
    isShowActionBtn: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    close() {
      this.$emit('close')
    },
    save() {
      this.$emit('save')
    },
  },
}
</script>
